//
// CadenceVersion.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";
import "@sas-dvr/ltjs-commons/models/particles/Link";

var CadenceVersion = createModule("transport::CadenceVersion", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        cadenceName: 7,
        cadenceVersion: 7,
        cadenceRelease: 7,
        links: [1],
        cadenceDisplayName: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default CadenceVersion;
